module.exports = __webpack_public_path__ + "fonts/latothin.9a77fbaa.ttf";